/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import { IntlContext } from 'react-intl';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import metadata from './Offerings.metadata.json5';
import messages from './Offerings.messages'
import styles from './Offerings.module.scss'
import AdditionalInsuredCoverage from '../AdditionalInsuredCoverage/AdditionalInsuredCoverage';
import AdditionalPremisesCoverage from '../AdditionalPremisesCoverage/AdditionalPremisesCoverage';
import TFPACoverablesUtils from '../../../util/TFPACoverablesUtils';

function Offerings(props) {

    const translator = useContext(TranslatorContext);
    const intlContext = useContext(IntlContext);

    const { onValueChange, submissionVM, onValueChangeAndSync, isCovLoading, showError, updateWizardData,
        isComponentValid, setCoverageValidation, showAdditionalFieldError, readOnly,discSurgValue,offeredQuote,
        isTFPACoverageSummary, authHeader,insuredValue, ho205CovValue,ho205CovDesc} = props;
        
    const policyType = submissionVM.lobData.homeowners_tfpa?.policyType_TWIA?.value?.code || 
    submissionVM.lobData.homeowners_tfpa.coverables.policyType_Ext.value.code;
    const ho205CovPremiumAmount = _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabPremium_Ext.value')


    const handleValueChange = useCallback((newValue, path, clause) => {
        onValueChange(newValue, path, clause);
    }, [onValueChange])

    const handleValueChangeAndSync = useCallback((newValue, path, clause) => {
        onValueChangeAndSync(newValue, path, clause);
    }, [onValueChangeAndSync])

    const hideHO205CoverageSection = useCallback(() => {
        const usage = TFPACoverablesUtils.dwellingUsage(submissionVM);
        // DE16381
        return policyType === 'DP2' || (policyType === 'HO6' && usage.code === 'rent');
    }, [policyType, submissionVM])

    const getAdditionalCoverages = useCallback(() => {
        const addCov = submissionVM.lobData.homeowners_tfpa.coverages.additionalCoverages.value

        return _.filter(addCov, (cov) => cov.publicID !== 'HO205')
    }, [submissionVM]);

    const getByCovLabel = useCallback(() => {
        const addCov = _.find(submissionVM.lobData.homeowners_tfpa.coverages.additionalCoverages.value, (cov) => cov.publicID === 'HO205')

        if (addCov && addCov.amount && !showAdditionalFieldError) {
            const formatterCurrency = intlContext.formatNumber(addCov.amount.amount, {
                style: 'currency',
                currency: addCov.amount.currency,
                // currencyDisplay: 'code',
            });

            return (<p>{`${translator(messages.ho205PremiumLabel)}`}&nbsp;&nbsp;<b>{`(Premium: ${formatterCurrency})`}</b></p>);
        }

        return translator(messages.ho205PremiumLabel)
    }, [intlContext, showAdditionalFieldError, submissionVM, translator])
    
    const showAdditionalPremisesTfpa = () => {
        const occupancy = TFPACoverablesUtils.occupancy(submissionVM);
        if (occupancy?.code === 'tenant' && policyType === 'HO6') {
            return false;
        }
    
        if (policyType === 'DP2') {
            return false;
        }
        return true;
    };
    
    const showAdditionalPersonsTfpa = () => {    
        if (policyType === 'DP2') {
            return false;
        }
        return true;
    };

    // DE16262
    const renderValueField = useCallback((rowData, rowIndex) => (
        <div style={{ 'display': 'flex', 'justify-content': 'end'}}>Premium:&nbsp;&nbsp;<CurrencyField
        id={`creditAmount_${rowIndex}`}
        value={rowData.amount}
        readOnly
    /></div>
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);

    // DE16446 
    const renderAddlNameField = useCallback((item) => <span>{item.accountContactDTO.displayName}</span>, []);

    const renderRelationType = (item) => item.relationshipToInsured;

    const renderCoverageType = (item, rowId) => {
        const additionalInsureds = _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalInsureds_Ext.value');

        const selectedInsured = Array.isArray(additionalInsureds) && additionalInsureds.length > 0 ? additionalInsureds[rowId] : {};

        const coveragesArray = Array.isArray(selectedInsured.coverages) ? selectedInsured.coverages : [];

        const coverage = coveragesArray.length > 0 ? coveragesArray[0] : undefined;

        const termsArray = Array.isArray(coverage?.terms) ? coverage.terms : [];

        const term = termsArray.length > 0 ? termsArray[0] : undefined;

        const chosenTermValue = term ? term.chosenTermValue : undefined;

        return chosenTermValue;
    };

    // DE16447
    const ho5CovData = [{ description: ho205CovDesc, coverageValue: ho205CovValue}]

    const renderDescription = (item) => item.description;

    const renderMedicalPayment = (item) => item.coverageValue ? 'INCLUDED' : 'NOT INCLUDED'
     

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        sectionICoverages: {
            value: submissionVM.lobData.homeowners_tfpa.coverages.sectionICoverages_Ext.value,
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'lobData.homeowners_tfpa.coverages.sectionICoverages_Ext',
            submissionVM,
            loadingClause: isCovLoading,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError,
            isEditable: !readOnly,   //US26839
            showAmount: true,
            showCoverageNameAmount: !readOnly,
            isTFPAResidentialSummary : readOnly,
            showAdditionalFieldError
        },
        sectionIICoverages: {
            value: submissionVM.lobData.homeowners_tfpa.coverages.sectionIICoverages_Ext.value,
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'lobData.homeowners_tfpa.coverages.sectionIICoverages_Ext',
            submissionVM,
            loadingClause: isCovLoading,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError,
            isEditable: !readOnly,   //US26839
            showAmount: true,
            showCoverageNameAmount: !readOnly,
            isTFPAResidentialSummary : readOnly,
            showAdditionalFieldError
        },
        additionalCoverages: {
            value: getAdditionalCoverages(),
            path: 'lobData.homeowners_tfpa.coverages.additionalCoverages',
            loadingClause: isCovLoading,
            submissionVM,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError,
            isEditable: !readOnly,   //US26839
            showAmount: true,
            showCoverageNameAmount: !readOnly,
            isTFPAResidentialSummary : readOnly,
            showAdditionalFieldError
        },
        exclusionsAndConditions: { // DE16271-Removed labelPosition
            value: submissionVM.lobData.homeowners_tfpa.coverages.exclusions_Ext.value,
            // eslint-disable-next-line no-secrets/no-secrets
            path: 'lobData.homeowners_tfpa.coverages.exclusions_Ext',
            submissionVM,
            loadingClause: isCovLoading,
            onValidate: setCoverageValidation,
            isComponentValid,
            showError,
            isEditable: !readOnly,    //US26839
            showAmount: true,
            showCoverageNameAmount: !readOnly,
            isTFPAResidentialSummary : readOnly,
            showAdditionalFieldError
        },
        premium: { 
            visible: !!readOnly //US26839
        },
        moreAdditionalCovs: {
            visible:  isTFPACoverageSummary? false : !hideHO205CoverageSection()
        },
        ho205Fields: {
            visible: submissionVM.lobData.homeowners_tfpa
                .coverages?.homeOfficeLiabCoverage_Ext?.value === true ,
            className: isTFPACoverageSummary ? 'covSum' : 'clauseAndTermSpacing', //DE16354
        },
        describeField: {
            readOnly: isTFPACoverageSummary, //DE16354
        },
        medicalPayment: {
            readOnly: isTFPACoverageSummary  //DE16354
        },
        sectionICovPremium: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionICoveragesTotal_Ext.value') !== undefined,
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionICoveragesTotal_Ext.value')
        },
        sectionIICovPremium: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionIICoveragesTotal_Ext.value') !== undefined,
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionIICoveragesTotal_Ext.value')
        },
        addCovPremium: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalCoveragesTotal_Ext.value') !== undefined,
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalCoveragesTotal_Ext.value')
        },
        exclCovPremium: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.exclusionsFeeTotal_Ext.value') !== undefined,
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.exclusionsFeeTotal_Ext.value')
        },
        premiumSectionI: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionICoveragesTotal_Ext.value') !== undefined
        },
        premiumSectionII: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.sectionIICoveragesTotal_Ext.value') !== undefined
        },
        premiumSectionAdd: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalCoveragesTotal_Ext.value') !== undefined,
        },
        premiumSectionExclusion: {
            visible: !showAdditionalFieldError && _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.exclusionsFeeTotal_Ext.value') !== undefined,
        },
        ho205Cov: {
            label: getByCovLabel(),
            readOnly: isTFPACoverageSummary //DE16354
        },
        AddlInsCoverageTable: {
            submissionVM,
            updateWizardData,
            onValueChangeAndSync,
            authHeader,
            visible: showAdditionalPersonsTfpa() &&  !readOnly
        },
        AddPrmsCoverageTable: {
            submissionVM,
            updateWizardData,
            onValueChangeAndSync,
            visible: showAdditionalPremisesTfpa() &&  !readOnly
        },
        discountSurcharges:{
            data: discSurgValue,
            visible: isTFPACoverageSummary? true : !showAdditionalFieldError &&
                _.get(offeredQuote, 'premium.total') !== undefined
        },
        discountPremium:{
            value:_.get(submissionVM,'lobData.homeowners_tfpa.coverages.discountSurchargeFeeTotal_Ext.value')
        },
        discountSurchargesTitle:{
            visible: isTFPACoverageSummary? true : !showAdditionalFieldError &&
            _.get(offeredQuote, 'premium.total') !== undefined
        },
        additionalCoveragesTitle:{
            visible:!_.isEmpty(_.get(submissionVM,'lobData.homeowners_tfpa.coverages.additionalCoverages.value'))
        },
        sectionICoveragesTitle:{
            visible:!_.isEmpty(_.get(submissionVM,'lobData.homeowners_tfpa.coverages.sectionICoverages_Ext.value'))
        },
        sectionIICoveragesTitle:{
            visible:!_.isEmpty(_.get(submissionVM,'lobData.homeowners_tfpa.coverages.sectionIICoverages_Ext.value'))
        },
        // DE16446
        addlInsuredTitle: {
            visible: isTFPACoverageSummary && insuredValue?.length > 0
        },
        additionalInsuredCoveragesTable: {
            data: insuredValue,
            visible: isTFPACoverageSummary && insuredValue?.length > 0
        },
        addlInsuredPremium: {
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.additionalInsuredsTotal_Ext.value')
        },
        // DE1644
        ho205CovTitle: {
            visible: isTFPACoverageSummary && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CoveragesTable: {
            data: ho5CovData,
            visible: isTFPACoverageSummary && !_.isUndefined(ho205CovPremiumAmount)
        },
        ho205CovPremium: {
            value: _.get(submissionVM, 'lobData.homeowners_tfpa.coverages.homeOfficeLiabPremium_Ext.value')
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            AddlInsCoverage: AdditionalInsuredCoverage,
            AddPrmsCoverage: AdditionalPremisesCoverage
        },
        resolveCallbackMap: {
            handleValueChange,
            handleValueChangeAndSync,
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField,
            renderAddlNameField: renderAddlNameField,
            renderRelationType: renderRelationType,
            renderCoverageType:renderCoverageType,
            renderDescription,
            renderMedicalPayment
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            showErrors={showError || showAdditionalFieldError}
            onValidationChange={setCoverageValidation}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

Offerings.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default Offerings;
